import { GET_DOMAIN, RE_LOADING } from "../actions/GetDomainsActions";

const initialState = {
  getdomains: [],
  loading: false,
  loadingvalidation: false,
  success: true,
};

const DomainsReducer = function (state = initialState, action) {
  switch (action.type) {
    case RE_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_DOMAIN: {
      return {
        ...state,
        getdomains: [...action.data],
        loading: false,
      };
    }

    default: {
      return state;
    }
  }
};

export default DomainsReducer;
